import { AuthRoute, ControllerWrapper, useRouteMatch } from "extensions/react-router";
import { UsersController } from "./usersController";

const controller = new UsersController();

export function UsersRouter() {
    const { url } = useRouteMatch();

    return (
        <>
            <AuthRoute exact path={`${url}/users`} render={() => <ControllerWrapper controller={controller} method="listAllUsers" />} />
            <AuthRoute path={`${url}/users/:id`} render={() => <ControllerWrapper controller={controller} method="openChildTab"/>} />
        </>
    );
}
